import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ServicesCardsPrivateCloud.css';
import { TimelineFormation } from '../../ui/timeline-formation';
import FeatureDetailModal from './FeatureDetailModal';
import './timeline-custom.css';

// Import icons directly
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm04.png';

interface DetailModalState {
  isOpen: boolean;
  title: string;
  content: string;
}

// Define necessary types locally based on usage
interface TimelineItemFeature {
  id: string;
  text: string; // Ensure text property exists
  detailContent?: string;
  // No element/renderDetail property - we don't want "Learn More" buttons for AzureAD timeline
}

interface TimelineItem {
  date: string;
  title: string;
  description: string;
  icon: string;
  features: TimelineItemFeature[];
}

// Timeline specifically for Azure Admin with exactly 5 modules and no Learn More buttons
const TimelineFormationAD: React.FC = () => {
  const { t } = useTranslation();
  const [detailModal, setDetailModal] = useState<DetailModalState>({
    isOpen: false,
    title: '',
    content: '',
  });

  // Use the locally defined feature type
  const openDetailModal = (feature: TimelineItemFeature) => {
    if (feature.detailContent) {
      setDetailModal({
        isOpen: true,
        title: feature.text,
        content: feature.detailContent,
      });
    }
  };

  const closeDetailModal = () => {
    setDetailModal((prev) => ({ ...prev, isOpen: false }));
  };

  // Azure Admin has exactly 5 modules
  const serviceIds = [1, 2, 3, 4, 5];

  const icons: { [key: number]: string } = {
    1: ProcessMobile1,
    2: ProcessMobile2,
    3: ProcessMobile3,
    4: ProcessMobile4,
    5: ProcessMobile5
  };
  const getIconForService = (id: number) => icons[id] || ProcessMobile1;

  const timelineItems: TimelineItem[] = serviceIds.map(id => {
    const serviceKey = `formationAD.timeline.services.${id}`;
    const featuresTranslationResult = t(`${serviceKey}.features`, { returnObjects: true, defaultValue: {} });

    const featuresData = typeof featuresTranslationResult === 'object' && featuresTranslationResult !== null 
      ? featuresTranslationResult as Record<string, { text?: string; detailContent?: string }> 
      : {};

    const featureKeys = Object.keys(featuresData);

    return {
      date: "",
      title: t(`${serviceKey}.title`),
      description: t(`${serviceKey}.description`),
      icon: getIconForService(id),
      features: featureKeys
        .map(featureId => {
          const featureTextKey = `${serviceKey}.features.${featureId}.text`;
          const featureDetailKey = `${serviceKey}.features.${featureId}.detailContent`;
          const translatedText = t(featureTextKey);
          const translatedDetail = t(featureDetailKey, { defaultValue: undefined });

          // No "Learn More" button for Azure Admin timeline
          const feature: TimelineItemFeature = {
            id: featureId,
            text: translatedText,
            detailContent: translatedDetail || undefined,
            // Intentionally NOT adding element property here
          };

          return feature;
        })
        .filter(f => f.text && f.text !== `${serviceKey}.features.${f.id}.text`), 
    };
  });

  useEffect(() => {
    const timelineCardTitles = document.querySelectorAll('.slider-cards h3.blue-h2-blue-bg');
    timelineCardTitles.forEach(element => {
      if (element instanceof HTMLElement) {
        element.style.paddingLeft = '30px';
      }
    });
  }, []);

  return (
    <div className="tw-container entra-timeline tw-mx-auto tw-px-4 tw-pb-16 tw-bg-transparent">
      <TimelineFormation items={timelineItems} showModule={true} moduleText="Module" />

      <FeatureDetailModal
        isOpen={detailModal.isOpen}
        onClose={closeDetailModal}
        title={detailModal.title}
        content={detailModal.content}
      />
    </div>
  );
};

export default TimelineFormationAD;